import { createApp } from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import router from "./router"
import store from "./store"
import i18n from "./translations"
import SocketPlugin from "@/plugins/socket"
import "@/assets/main.scss"
import { vPriceFormat } from "@/directives/price-format"
import { vPercent } from "./directives/v-percent"
import { clickOutside } from "./directives/v-click-outside"
import { initTawk } from "@/utils"

const app = createApp(App)
app.use(i18n)
app.use(store)
app.use(router)
app.use(SocketPlugin)

app.directive("price-format", vPriceFormat)
app.directive("percent", vPercent)
app.directive("click-outside", clickOutside)

app.mount("#app")

router.isReady().then(() => {
  const currentRoute = router.currentRoute.value

  if (!currentRoute.path.startsWith("/admin")) {
    initTawk(app)
  }
})
